/* eslint-disable react-hooks/exhaustive-deps */
import * as React from 'react';


import {
  Box,
} from '@mui/material';

import Header from '../../components/LandingPage/layout/header';
import { Middle } from '../../components/layout/middle';
import { BaseDiv } from './styles';
import { Footer } from '../../components/layout/footer';
import { Content } from '../../components/LandingPage/layout/Content';
import { useEffect } from 'react';


const GTM_ID = "GTM-5Z4DPPB5";

const LandingPage: React.FC = () => {

  const ref: any = React.useRef(null);
  const refmid = React.useRef(null);
  const [dadosRef, setDadosRef] = React.useState<React.RefObject<HTMLDivElement>>(React.createRef<HTMLDivElement>());
  const [refTitle, setRefTitle] = React.useState(null);

  useEffect(() => {
    const handleResize = () => {
      setDadosRef(ref.current);
      setRefTitle(ref?.current?.title)
    };

    window.addEventListener('resize', handleResize);

    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [dadosRef, ref]);

  useEffect(() => {
    // ---- Adiciona o script do GTM ----
    const script = document.createElement("script");
    script.innerHTML = `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id=${GTM_ID}'+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${GTM_ID}');
    `;
    document.head.appendChild(script);

    // ---- Adiciona o noscript ----
    const noscript = document.createElement("noscript");
    noscript.innerHTML = `
      <iframe src="https://www.googletagmanager.com/ns.html?id=${GTM_ID}" 
      height="0" width="0" style="display:none;visibility:hidden"></iframe>
    `;
    document.body.appendChild(noscript);

    return () => {
      // remove se sair da landing page
      document.head.removeChild(script);
      document.body.removeChild(noscript);
    };
  }, []);

  return (
    <BaseDiv>
      <Box>
          <Box>
            <Header reference={dadosRef} title={refTitle}/>
            <Content />
          </Box>
        </Box>
    </BaseDiv>
  );
}

export { LandingPage }